import { BigNumber } from "bignumber.js";
//? **********************
//? BigNumber JS   *
//? **********************
const FORMAT = {
  prefix: "",
  decimalSeparator: ".",
  groupSeparator: ",",
  groupSize: 3,
  secondaryGroupSize: 0,
  fractionGroupSeparator: " ",
  fractionGroupSize: 0,
  suffix: "",
};
BigNumber.config({ FORMAT });

export const takeSeparatorFormat = (number) => {
  if ((!number && number !== 0) || Number.isNaN(+number) || number === Infinity) return number;

  number = String(number);
  number = number.replace(/,/g, "");

  let [integer] = number.split(".");
  if (!integer) return number;

  const foundDot = number.indexOf(".") > -1;
  const integerPart = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const decimalPart = foundDot ? number.substring(number.indexOf("."), number.length) : "";

  return `${integerPart}${decimalPart}`;
};
// ? **********************

// ! **********************
// ! CORE CALCULATE   *
// ! **********************
export function calculate(algebraic, decimal, roundingMode = 4) {
  // result = safeOperatorMainCalculate(num_1, num_2, operator); // deprecated
  let result = postfixCalculate(algebraic);

  // include extranal lib (bignumber.js)
  if (decimal !== undefined && decimal !== null) {
    result = +rounding(result, decimal, roundingMode);
  }

  return result;
}

function safeOperatorMainCalculate(num1, num2, operator) {
  num1 = +num1;
  num2 = +num2;

  if (Number.isNaN(num1) || Number.isNaN(num2)) {
    return Number.NaN;
  }

  const decimalNum1 = countDecimalPlace(num1);
  const decimalNum2 = countDecimalPlace(num2);
  const fixDecimalPlace = Math.max(decimalNum1, decimalNum2);
  const signNum1 = `${num1}`.indexOf(".") !== -1 ? `${num1}`.indexOf(".") : `${num1}`.length;
  const signNum2 = `${num2}`.indexOf(".") !== -1 ? `${num2}`.indexOf(".") : `${num2}`.length;
  const fixedNum1 = +`${num1}`.replace(".", "").padEnd(signNum1 + fixDecimalPlace, "0");
  const fixedNum2 = +`${num2}`.replace(".", "").padEnd(signNum2 + fixDecimalPlace, "0");
  let result;
  switch (operator) {
    case "+":
      result = (fixedNum1 + fixedNum2) / Math.pow(10, fixDecimalPlace);
      break;
    case "-":
      result = (fixedNum1 - fixedNum2) / Math.pow(10, fixDecimalPlace);
      break;
    case "*":
      result = (fixedNum1 * fixedNum2) / Math.pow(Math.pow(10, fixDecimalPlace), 2);
      break;
    case "/":
      result = fixedNum1 / fixedNum2;
      break;
    case "%":
      result = (fixedNum1 % fixedNum2) / Math.pow(10, fixDecimalPlace);
      break;
    default:
      result = Number.NaN;
      break;
  }
  // console.log({
  //     result,
  //     operator,
  //     num1, num2,
  //     decimalNum1, decimalNum2,
  //     fixDecimalPlace,
  //     signNum1, signNum2,
  //     fixedNum1, fixedNum2,
  // })
  return result;
}

export function countDecimalPlace(num) {
  if (!num && num !== "0" && num !== 0) return 0;

  const strNum = `${num}`;
  if (strNum.indexOf(".") > 0) {
    return `${num}`.replace(/.*\./, "").length;
  } else {
    return 0;
  }
}

function postfixCalculate(literal) {
  literal = literal.replace(/[{[<]/g, "(").replace(/[}\]>]/g, ")");

  // validate syntax
  if ((literal.match(/\(/g) || []).length !== (literal.match(/\)/g) || []).length) {
    // check bracket
    throw new Error("Error match brackets");
  }

  // process
  const postfix = toPostfix(literal);
  const stack = [];
  postfix.forEach((op) => {
    if (["+", "-", "*", "/", "%"].includes(op)) {
      const operand_2 = stack.pop();
      const operand_1 = stack.pop();
      stack.push(safeOperatorMainCalculate(operand_1, operand_2, op));
    } else {
      stack.push(+op);
    }
  });
  return stack[0];
}

function getOperatorScore(op) {
  if ("()".includes(op)) return 4;
  // if ( ['!', '++', '--'].includes(op) )  // not allow now
  // 	return 3;
  if ("*/%".includes(op)) return 2;
  if ("+-".includes(op)) return 1;
}

function prepareLiteralBeforePostfix(literal) {
  return literal
    .replace(/\s/g, "")
    .replace(/[+\-*/%]\D|[+\-*/%]/g, (operator) =>
      operator.length === 2 ? ` ${operator[0]} ${operator[1]}` : ` ${operator} `
    )
    .trim()
    .replace(/(^-\s*|\(\s*-\s*)\d/g, (m) => m.replace(/\s/g, "")); // fix first operand is negative
}

function toPostfix(literal) {
  const stack = [],
    stackOperator = [];
  literal = prepareLiteralBeforePostfix(literal);
  const literalChars = literal.match(/(-?\d+(\.\d+)?)|([()+\-*/%])/g);

  literalChars.forEach((op) => {
    if (["+", "-", "*", "/", "%", "(", ")"].includes(op)) {
      if (stackOperator.length !== 0 && stackOperator[stackOperator.length - 1] !== "(") {
        if (op === ")") {
          do {
            stack.push(stackOperator.pop());
          } while (stackOperator[stackOperator.length - 1] !== "(");
          stackOperator.pop(); // get rid of '('
        } else {
          const opScore = getOperatorScore(op);
          while (stackOperator.length > 0 && opScore <= getOperatorScore(stackOperator[stackOperator.length - 1])) {
            stack.push(stackOperator.pop());
          }
          stackOperator.push(op);
        }
      } else {
        stackOperator.push(op);
      }
    } else {
      stack.push(op);
    }
  });

  while (stackOperator.length > 0) stack.push(stackOperator.pop());

  return stack;
}
// ! **********************
// ! END CORE CALCULATE   *
// ! **********************

//* Rounding Mode Config
//* -    0 : ROUND_UP
//* -    1 : ROUND_DOWN
//* -    2 : ROUND_CEIL
//* -    3 : ROUND_FLOOR
//* -    4 : ROUND_HALF_UP
//* -    5 : ROUND_HALF_DOWN
//* -    6 : ROUND_HALF_EVEN
//* -    7 : ROUND_HALF_CEIL
//* -    8 : ROUND_HALF_FLOOR
//*
//* - DEFAULT : ROUND_HALF_UP
export const formatNumber = (number, precision, options = {}) => {
  const {
    preserveDot,
    preserveDecimal,
    preserveInteger,
    noSep,
    trimZeroDecimal,
    dontRound,
    roundingMode = 4,
  } = options;

  number = String(number).replace(/,/g, "");
  if ((!number && number !== 0) || Number.isNaN(+number)) return number;

  const originStartsWithDot = number[0] === ".";
  const originEndsWithDot = number[number.length - 1] === ".";
  const numberOfDecimal = number.match(/\.(\d+)/)?.[1].length ?? 0;

  // rounding when specify precision
  if (precision !== undefined && precision !== null) {
    if (dontRound) {
      // ถ้า dp เกินใช้วิธีตัดส่วนที่เกินออก, rm จะไม่มีผลถ้า dp พอดี
      if (numberOfDecimal > precision) {
        const cutPosition = number.indexOf(".") + precision + 1;
        number = number.substr(0, cutPosition);
      }
    }
    // ถ้าไม่อยากให้มีการ padding 0 ที่ dp
    if (!preserveDecimal) {
      number = BigNumber(number).toFixed(precision, roundingMode);
    }
  }

  const foundDot = number.indexOf(".") > -1;
  const [integer, decimal = ""] = number.split(".");
  const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  number = `${formattedInteger}${foundDot && decimal ? "." : ""}${decimal}`;

  if (originStartsWithDot && preserveInteger) {
    // case remove 0 :: '0.15' => '.15'
    number = number.replace(/\d+\./, ".");
  }
  if (originEndsWithDot && preserveDot && number.indexOf(".") === -1) {
    number += ".";
  }
  if (noSep) {
    // number = number.replaceAll(',', '');
    number = number.replace(/,/g, "");
  }
  if (trimZeroDecimal) {
    number = number.replace(/(\.[0-9]*?)0+$/, (_, realDecimal) => (realDecimal !== "." ? realDecimal : ""));
  }

  return number;
};

export const formatInteger = (number) => formatNumber(number);
export const format2Decimal = (number) => formatNumber(number, 2, { dontRound: true });
export const format4Decimal = (number) => formatNumber(number, 4, { dontRound: true });
export const format5Decimal = (number) => formatNumber(number, 5, { dontRound: true });

export const formatDynamicDecimal = (value, precision = 2) => {
  const decimal =
    typeof value === "number"
      ? value.toString().split(".")[1]
      : typeof value === "string" && value.includes(".")
        ? value.split(".")[1]
        : undefined;
  if (!decimal || decimal.length <= precision) {
    return formatNumber(value, precision);
  }
  return value;
};

// To keep backward compatibility, alias the previous name:
export const formatSellPriceUnit = (value) => formatDynamicDecimal(value, 2);

// allow single dot
export function onlyNumberIncludeDot(value) {
  return (event) => {
    if (!/[\d.]/.test(event.key) || (event.key === "." && typeof value === "string" && value.indexOf(".") > -1)) {
      event.preventDefault();
      return false;
    }
  };
}

export function onlyNumber(event) {
  if (!/\d/.test(event.key)) {
    event.preventDefault();
    return false;
  }
}

export function workAroundNumber(number) {
  return number === "-" || number === "" || number === "." || number === "-." ? 0 : isNumber(number) ? +number : 0;
}

export function isNumber(number) {
  return (
    number !== null &&
    number !== undefined &&
    number !== "" &&
    (typeof number === "string" || typeof number === "number") &&
    isFinite(number)
  );
}

export const cutDecimal = (number) => {
  if (!isNumber(number)) return number;
  return +formatNumber(number, 0, { dontRound: true }).replace(/,/g, "");
};

export function padDecimalZero(number, decimal) {
  if (number === null || number === "null" || !decimal) return number;

  if (typeof number === "string") number = number.replace(/,/g, "");

  const dotIndex = `${number}`.indexOf(".");
  if (dotIndex !== -1) {
    let leftSignt = dotIndex + 1;
    return leftSignt !== 0
      ? `${number}`.padEnd(leftSignt + +decimal, "0")
      : `${number}.`.padEnd(`${number}`.length + 1 + +decimal, "0");
  } else {
    return `${number}`;
  }
}

export function convertDecimalNumberToText(num) {
  if (isNumber(+num)) {
    if (/e[-+]{1}/i.test(`${num}`)) {
      return toFixed(num);
    } else {
      return `${num}`;
    }
  }
  return num;
}

export function toFixed(x) {
  if (Math.abs(x) < 1.0) {
    let e = parseInt(x.toString().split(/e-/i)[1]);
    if (e) {
      x *= Math.pow(10, e - 1);
      x = "0." + new Array(e).join("0") + x.toString().substring(2);
    }
  } else {
    let e = parseInt(x.toString().split("+")[1]);
    if (e > 20) {
      e -= 20;
      x /= Math.pow(10, e);
      x += new Array(e + 1).join("0");
    }
  }
  return x;
}

export function unExponential(num, opts = {}) {
  const { decimal, autoPadDecimal } = opts;

  const normalFormNumber = convertDecimalNumberToText(num);
  return autoPadDecimal ? padDecimalZero(normalFormNumber, decimal) : normalFormNumber;
}

export function rounding(number, decimal, roundingMode = 4) {
  if (!number || decimal === undefined || decimal === null) return number;
  return new BigNumber(number).toFixed(decimal, roundingMode);
}
